import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createProgramInvoice } from "../../api/apiInvoices";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export const useCreateProgramInvoice = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const lang = i18n.language;

    const { mutate: createProgramInvoiceMutate, isPending } = useMutation({
        mutationFn: ({ programId, data }) => createProgramInvoice(programId, data),
        onSuccess: (data, variables) => {
            toast.success(lang === "ar" ? "تم إنشاء الفاتورة بنجاح" : "Invoice created successfully");
            queryClient.invalidateQueries(["programInvoice", variables.programId]);
            queryClient.invalidateQueries(["program", variables.programId]);
        },
        onError: (error) => {
            const errorMessage =
                error.response?.data?.message ||
                (lang === "ar" ? "حدث خطأ أثناء إنشاء الفاتورة" : "An error occurred while creating the invoice");
            toast.error(errorMessage);
        },
    });

    return { createProgramInvoiceMutate, isPending };
};

export default useCreateProgramInvoice;
